import React from 'react';
import classNames from 'classnames';

const defaultStyles = {};

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function ButtonGroup({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  style = defaultStyles,
  block = false,
  stick = 'none',
  children,
  ...otherProps
}) {
  const hasStick = stick !== 'none';

  const buttonGroupClass = classNames(className, 'ws-button-group', {
    'ws-button-group--block': block,
    [`ws-button-group--stick-${stick}`]: hasStick,
  });

  return (
    <div className={buttonGroupClass} style={style} {...otherProps}>
      {children}
    </div>
  );
}

export default ButtonGroup;
